import React from "react";
import { Timer, RefreshCw, Wrench, ShieldCheck } from "lucide-react";
import { features } from "../mock";

const iconMap = { Timer, RefreshCw, Wrench, ShieldCheck };

const Features = () => {
  return (
    <section className="relative bg-[#f5f5f6] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#f15a24]">
            Why Posi
          </span>
          <h2 className="font-display font-semibold text-neutral-900 text-4xl sm:text-5xl mt-4">
            Engineered to make life easier
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={f.title}
                className="group bg-white rounded-2xl p-8 border border-neutral-200/70 hover:border-[#f15a24]/40 hover:shadow-xl hover:shadow-neutral-200 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#f15a24]/10 text-[#f15a24] group-hover:bg-[#f15a24] group-hover:text-white transition-colors duration-300">
                  <Icon size={26} strokeWidth={2} />
                </div>
                <h3 className="font-display font-semibold text-neutral-900 text-xl mt-6">
                  {f.title}
                </h3>
                <p className="text-neutral-500 mt-3 leading-relaxed text-[15px]">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
